module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq415-1ebbdcbd33f59354c4d3514e7073176b.jpg";